"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printScalingSelector = void 0;
exports.printScalingSelector = ".scale-2x.print-styling-v3";
